import * as Sentry from "@sentry/browser";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn:
      "https://a9f7be755f89446d91a078ff8b01682f@o400034.ingest.sentry.io/5258019",
  });
}
